import type { SxProps, Theme } from '@mui/material';

/** Compose styles in order; later entries override earlier ones. Theme functions stay unevaluated. */
const mergeSx = (...styles: (SxProps<Theme> | false | null | undefined)[]): SxProps<Theme> =>
  styles.flatMap(sx => (sx ? (Array.isArray(sx) ? sx : [sx]) : []));

export default mergeSx;
